import { REGISTRATION_STATUSES } from 'api/auth/constants'

export const PENDING_INFO = {
  title: "You're well on your way to go live",
  description:
    "Please follow the steps listed on the right and wait for approval. If everything is okay, it won't take long.",
}

export const APPROVAL_INFO = {
  title: 'You did great!',
  subTitle: "You're almost done with the onboarding.",
  stepOneTitle: "What's next?",
  stepOneDescription: `We will verify the information you provided. Don't worry, it won't take
  much time.`,
  stepTwoTitle: 'Why do we need this?',
  stepTwoDescription:
    'We just want to ensure that everything meets our high standards',
  stepThreeTitle: 'In the meantime…',
  stepThreeDescription: `Prepare prices, a list of optional extras and rental Terms & Conditions.
      You will need them to complete the onboarding process.`,
}

export const PROFILE_INFO = {
  title: 'Profile',
  description: 'Add basic information about your business',
}

export const DOCUMENTS_INFO = {
  title: 'Documents',
  description: 'Add the docs to verify company info',
}

export const LOCATION_INFO = {
  title: 'Locations',
  description: 'Add the locations you operate in',
}

export const CARS_INFO = {
  title: 'Cars',
  description: 'Add the cars you have in your fleet',
}

export const PRICE_LIST_INFO = {
  title: 'Price list',
  description: 'Add seasonal and daily price ranges',
}

export const TERMS_INFO = {
  title: 'T&C',
  description: 'Add T&Cs for your car rentals',
}

export const CARD_BLOCK_TITLE = 'Finish onboarding'
export const CARD_BLOCK_TITLE_DONE = '3 out of 3 complete'

export const APPROVAL_INFO_BADGES = {
  REQUESTED: 'The requested information has been emailed to you.',
  SUBMIT:
    'Fill out the required information to complete your profile and access other sections.',
}

export const STATUS_BADGE_STATUSES = {
  [REGISTRATION_STATUSES.REVIEW]: 'IN REVIEW',
  [REGISTRATION_STATUSES.REQUESTED]: 'REQUESTED',
  [REGISTRATION_STATUSES.APPROVED]: 'CONFIRMED',
  [REGISTRATION_STATUSES.REJECTED]: 'REJECTED',
}

export const PENDING_CARD_TOOLTIP =
  'The requested information has been emailed to you.'

export const PENDING_FOR_APPROVAL_BADGE = {
  REQUESTED:
    'Other pages are not available until the requested information is added.',
  INCOMPLETE:
    'Fill out the required information to complete your profile and access other sections.',
  REVIEW: {
    INFORMATION_SUBMITTED: 'Your information has been submitted for review.',
    WE_WILL_KEEP_YOU_UPDATED: 'We will keep you updated.',
  },
  APPROVED: {
    COMPLETE_ALL_REQUIRED_SECTIONS: 'Please fill out all required sections.',
    NOTE_THAT_OTHER_PAGES_ARE_OPTIONAL: 'Optional sections can be left blank.',
  },
}
